<template>
  <CardFormLayout card-title="Change Password">
    <template #fields>
      <PasswordField
        v-model="password"
        label="Current Password"
        placeholder="Enter your current password"
        :rules="passwordRules"
      />
      <PasswordField
        v-model="newPassword"
        label="New Password"
        placeholder="Enter your new password"
        :password-rules="newPasswordRules"
      />
      <PasswordField
        v-model="confirmNewPassword"
        label="Confirm New Password"
        placeholder="Confirm your new password"
        :error-messages="emailMatchError"
        :rules="confirmNewPasswordRules"
      />
    </template>
    <template #actions>
      <SubmitButton
        :loading="isLoaderShown"
        :disabled="isDisabled"
        @click="submit"
      >
        Change Password
      </SubmitButton>
    </template>
  </CardFormLayout>
</template>
<script lang="ts" setup>
  import { ref, computed } from 'vue';
  // import components
  import CardFormLayout from '@/components//Layouts/CardFormLayout.vue';
  import PasswordField from '@/components/PasswordField.vue';
  import SubmitButton from '@/components/SubmitButton.vue';
  const props = defineProps({
    passwordRules: {
      type: undefined,
      default: () => [(v: string) => !!v || 'Password is required'],
    },
    newPasswordRules: {
      type: undefined,
      default: () => [(v: string) => !!v || 'New Password is required'],
    },
    confirmNewPasswordRules: {
      type: undefined,
      default: () => [(v: string) => !!v || 'Confirm Password is required'],
    },
    isLoaderShown: {
      type: Boolean,
      default: false,
    },
  });
  const confirmNewPassword = ref('');
  const newPassword = ref('');
  const password = ref('');

  let emit = defineEmits(['onChange']);

  let submit = () => {
    emit('onChange', {
      password: password.value,
      newpassword: newPassword.value,
    });
  };
  let emailMatchError = computed(() => {
    return newPassword.value === confirmNewPassword.value
      ? ''
      : 'Passwords do not match';
  });
  let emailMatch = computed(() => {
    return newPassword.value === confirmNewPassword.value ? true : false;
  });

  let isDisabled = computed(() => {
    // check if rules and emailMatch is boolean and if its true only then return false
    const passwordIsValid = props.passwordRules.every(
      (rule) => rule(password.value) === true
    );
    const newPasswordIsValid = props.newPasswordRules.every(
      (rule) => rule(newPassword.value) === true
    );
    const confirmNewPasswordIsValid = props.confirmNewPasswordRules.every(
      (rule) => rule(confirmNewPassword.value) === true
    );
    const passwordsMatch = emailMatch;
    return !(
      passwordIsValid &&
      newPasswordIsValid &&
      passwordsMatch &&
      confirmNewPasswordIsValid
    );
  });
</script>
